export default [ {
		path: '/productscheme',
		name: 'product',
		component: resolve => require(['../../views/product.vue'], resolve),
	}, {
		path: '/business',
		name: 'business',
		component: resolve => require(['../../views/business.vue'], resolve),
	}, {
		path: '/apply',
		name: 'apply',
		component: resolve => require(['../../views/apply.vue'], resolve),
	}, {
		path: '/login',
		name: 'login',
		component: resolve => require(['../../views/login.vue'], resolve),
	}, {
		path: '/register',
		name: 'register',
		component: resolve => require(['../../views/register.vue'], resolve),
	}
];
